// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2zAhH","checkboxCol":"Table_checkboxCol__1Vkcw","emailCol":"Table_emailCol__o8EG8","actionCol":"Table_actionCol__3y1CM"};